<script>
import Layout from "@/router/layouts/main";
import PlantaoHistory from "@/components/plantao/PlantaoHistory";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    PlantaoHistory,
  },
  methods: {
    goAccess() {
      this.$router.push("/telemedicina/plantao");
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Histórico</h3>
        <p>Seus pagamentos do plantão médico online e o status da consulta de cada um.</p>
      </div>
    </div>

    <PlantaoHistory @go-access="goAccess" />
  </Layout>
</template>
